<mat-toolbar>
  <h3>Reported vs. Capacity</h3>
  <span class="spacer"></span>
  @if (pending()) {
    <button matIconButton disabled class="rotating">
      <mat-icon>refresh</mat-icon>
    </button>
  }
</mat-toolbar>

<div class="cell-actions">
  <mat-form-field>
    <mat-label>Enter a date range</mat-label>
    <mat-date-range-input [rangePicker]="picker">
      <input matStartDate required placeholder="Start date" [(ngModel)]="StartDate" />
      <input matEndDate required placeholder="End date" [(ngModel)]="EndDate" />
    </mat-date-range-input>
    <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>
</div>

<table mat-table [dataSource]="source()" [trackBy]="trackBy">
  <tr mat-header-row *matHeaderRowDef="columnsToShow()"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: columnsToShow()"
    (click)="row.individual || toggleRow(row.team)"
    [class.pointable]="!row.individual"
    [hidden]="row.individual && !expanded()[row.team]"
  ></tr>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Team</th>
    <td mat-cell *matCellDef="let item">
      @if (item.individual) {
        <em>{{ item.name }}</em>
      } @else {
        <strong>{{ item.name }}</strong>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="total_time">
    <th mat-header-cell *matHeaderCellDef>Total hours</th>
    <td mat-cell *matCellDef="let item">{{ item.total_time | number: '.0-2' }}</td>
  </ng-container>

  <ng-container matColumnDef="chargeable_time">
    <th mat-header-cell *matHeaderCellDef>Chargeable hours</th>
    <td mat-cell *matCellDef="let item">{{ item.chargeable_time | number: '.0-2' }}</td>
  </ng-container>

  <ng-container matColumnDef="cap">
    <th mat-header-cell *matHeaderCellDef>Capacity</th>
    <td mat-cell *matCellDef="let item">{{ item.cap | number: '.0-2' }}</td>
  </ng-container>

  <ng-container matColumnDef="rate">
    <th mat-header-cell *matHeaderCellDef>Rate</th>
    <td mat-cell *matCellDef="let item">{{ (item.chargeable_time / (item.cap || 1)) * 100 | number: '.0-2' }} %</td>
  </ng-container>

  <ng-container matColumnDef="diff">
    <th mat-header-cell *matHeaderCellDef matTooltip="(total - chargeable)">Difference</th>
    <td mat-cell *matCellDef="let item" matTooltip="(total - chargeable)">
      {{ item.total_time - item.chargeable_time | number: '.0-2' }}
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let item">
      @if (!item.individual) {
        <mat-icon>
          @if (expanded()[item.team]) {
            unfold_less
          } @else {
            unfold_more
          }
        </mat-icon>
      }
    </td>
  </ng-container>
</table>
